


<!--<button class="btn btn-secondary" (click)="OnOpenModal()">Open</button>

<mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Client Picker</mat-label>
    <input type="text" matInput >
</mat-form-field>-->

<div class="alert alert-info" (click)="OnOpenModal()" style="cursor:pointer">
    <span *ngIf="ClientSSParam">{{ClientSSParam.clientInfo.firstName}} {{ClientSSParam.clientInfo.lastName}}</span>
    <span *ngIf="!ClientSSParam && ClientDTO$ | async as ClientDTO">{{ClientDTO.firstName}} {{ClientDTO.lastName}}</span>
    <span *ngIf="!ClientSSParam && !(ClientDTO$ | async)">[Select a Client]</span>
</div>
